/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { isCurrentTimezone } from '@web/src/lib/utilsClient'
import { useSyncExternalStore } from 'react'

const subscribe = () => () => {
  /* Browser timezone does not emit change events. */
}

const getServerSnapshot = () => true

/**
 * Whether `timezone` matches the browser timezone.
 * SSR and the first client paint assume a match so timezone-only UI does not hydrate-mismatch.
 */
export const useIsCurrentTimezone = (timezone: string | null | undefined): boolean => {
  return useSyncExternalStore(subscribe, () => isCurrentTimezone(timezone ?? ''), getServerSnapshot)
}
